module.exports = __webpack_public_path__ + "img/file.b2d1abc0.jpg";